import React, { useState } from 'react'
import Button from '../../../components/ui/Button'
import RissExportPanel from './RissExportPanel'
import RissXmlExportPanel from './RissXmlExportPanel'

export default function RissReportingPanel({ xmlProps, csvProps }) {
  const [format, setFormat] = useState('xml')
  return <div className="space-y-3">
    <div className="flex gap-2" aria-label="RISS export format">
      <Button type="button" variant={format === 'xml' ? 'default' : 'outline'} aria-pressed={format === 'xml'} onClick={() => setFormat('xml')}>XML reporting</Button>
      <Button type="button" variant={format === 'csv' ? 'default' : 'outline'} aria-pressed={format === 'csv'} onClick={() => setFormat('csv')}>CSV / ZIP alternative</Button>
    </div>
    <div hidden={format !== 'xml'}><RissXmlExportPanel {...xmlProps} /></div>
    <div hidden={format !== 'csv'}><RissExportPanel {...csvProps} /></div>
  </div>
}
